import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const ModifierSelection = (props) => {
  const { modifiers, onBack, onNext, onValueChange, selectedModifierName } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose the modifier you want to simulate</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>
            You can customize the status payload by selecting a specific modifier available to the
            machine
          </p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-modifier"
            getOptionLabel={(option) => option.label ?? option}
            options={modifiers}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
              onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Modifier" />}
            value={selectedModifierName}
            isOptionEqualToValue={(option, value) => option.label === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedModifierName,
          })}
          disabled={!selectedModifierName}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

ModifierSelection.propTypes = {
  modifiers: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onValueChange: PropTypes.func.isRequired,
  selectedModifierName: PropTypes.string,
};

export default ModifierSelection;
